import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

declare let gtag: Function;

if (environment.googleAnalyticsId) {
  if (typeof gtag === 'function') {
    try {
      gtag('config', environment.googleAnalyticsId, { 'send_page_view': false  });
    } catch (err) {
      //console.warn("La función gtag no está definida al inicio, catch")
    }
  } else {
    //console.warn('La función gtag no está definida al inicio, else');
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
